module.exports = __webpack_public_path__ + "img/gameshow2.ed7290a3.svg";